import { render } from "./crm-cases.vue?vue&type=template&id=306c0745&scoped=true"
import script from "./crm-cases.vue?vue&type=script&lang=js"
export * from "./crm-cases.vue?vue&type=script&lang=js"

import "./crm-cases.vue?vue&type=style&index=0&id=306c0745&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306c0745"]])

export default __exports__